import React from 'react';
import { AppBar, Box, IconButton, Toolbar } from '@material-ui/core';
import { MenuSharp } from '@material-ui/icons';
import AdminControls from './AdminControls';
import logo from '../../assets/soundive/soundive_yellow.png';
import { ADMIN_PANEL_AFTER } from '../../config/config';
import FontSizeSelector from './FontSizeSelector';
import { useSession } from '../contexts/session';
import { useLanguage } from '../contexts/language';

const toolbar = {
  justifyContent: 'space-between',
  paddingTop: '10px',
  paddingBottom: '10px',
};

export default function Header() {
  const { lightOnboarding } = useSession();
  const { content } = useLanguage();

  const [showControlsMenu, setShowControlsMenu] = React.useState(false);

  const [showAdmin, setShowAdmin] = React.useState(0);

  const openAdminDialog = () => {
    setShowAdmin((prev) => prev + 1);
    setTimeout(() => {
      setShowAdmin((prev) => (prev < ADMIN_PANEL_AFTER ? 0 : prev));
    }, ADMIN_PANEL_AFTER * 1000);
  };

  React.useEffect(() => {
    setShowControlsMenu(showAdmin >= ADMIN_PANEL_AFTER);
  }, [showAdmin]);

  React.useEffect(() => {
    if (!showControlsMenu) {
      setShowAdmin(0);
    }
  }, [showControlsMenu]);

  return (
    <AppBar position="static" color="transparent">
      <Toolbar style={toolbar}>
        <Box position="absolute" top={0} left={0} textAlign="left">
          <FontSizeSelector />
        </Box>

        {lightOnboarding ? (
          <>
            <Box position="absolute" top={0} right={0} textAlign="right">
              <IconButton
                onClick={() => setShowControlsMenu(true)}
                aria-label={content('aria_open_controls_menu')}
                title={content('aria_open_controls_menu')}
              >
                <MenuSharp style={{ fontSize: '1.5rem' }} />
              </IconButton>
            </Box>
            <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '12px' }}>
              <img alt="Soundive Agami" src={logo} height="30px" />
            </Box>
          </>
        ) : (
          <Box
            aria-hidden
            onClick={openAdminDialog}
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              cursor: 'pointer',
              paddingTop: '12px',
            }}
          >
            <img alt="Soundive Agami" src={logo} height="30px" />
          </Box>
        )}
      </Toolbar>
      <AdminControls
        show={showControlsMenu}
        onClose={() => setShowControlsMenu(false)}
        showLanguageSelector
      />
    </AppBar>
  );
}
